import { Box, Grid, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { LIGHT_GREY } from "styles/oneOffColor";

import MobilePlanCardPro from "../Plan/MobilePlanCard/Pro";
import MobilePlanCardVirtualAssistant from "../Plan/MobilePlanCard/VirtualAssistant";

interface Props {
  closeDialog: () => void;
}

const OnboardingPaywallMobile = ({ closeDialog }: Props) => {
  return (
    <Box
      sx={{
        backgroundColor: LIGHT_GREY,
        p: 3,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        overflowY: "auto",
      }}
    >
      <Grid container justifyContent="space-between" alignItems={"flex-start"}>
        <Box>
          <Typography sx={{ fontSize: 16, mb: -1 }} color="textSecondary">
            Unlock the tools to
          </Typography>
          <Typography variant="h3">grow faster ⚡</Typography>
        </Box>
        <IconButton
          sx={{
            color: grey[400],
          }}
          onClick={closeDialog}
        >
          <Box component="i" className="fa-thin fa-xmark" />
        </IconButton>
      </Grid>
      <MobilePlanCardPro />
      <MobilePlanCardVirtualAssistant />
    </Box>
  );
};

export default OnboardingPaywallMobile;
